import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges , ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FileSystemDirectoryEntry, FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { CommonService } from 'src/app/core/services/common.service';
import { JsonValidatorComponent } from '../../shared/json-validator/json-validator.component';
import { SharedService } from '../../shared/services/shared.service';
import { GmsconfirmComponent } from '../dialogs/gmsconfirm/gmsconfirm.component';
import { UtilService } from '../services/util/util.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    providers: [NgbActiveModal],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Output() getResponce = new EventEmitter();
  @Output() getFileData = new EventEmitter();
  private fileType = null;
  //private fileUploadPtah = '/home/cozy_image_store/bingo/assets/sounds/en_US/';
  private fileUploadPtah = 'cozy_image_store/bingo/assets/sounds/en_US/';
  private status;
  public showMsg: boolean = false;
  public errorMsg: string;
  public successMsg: string;
  public showSuccessMsg: boolean = false;
  public showErrorMsg: boolean = false;
  private statusMsgTimeOut;
  public fileAllowed: boolean = false;
  public isValid: boolean = true;

  private linesR = [];
  fileData = [];
  public pageTitle;
  updatedfileData: any;
  multipleUploadAllowed: boolean;
  private urlPrefix: any = '/bingo_shared_assets/';

  files: NgxFileDropEntry[] = [];
  @Input() fileMsg;
  @Input() callPage;
  @Input() prID;
  @Input() configObj;
  @Input() showFileUpload;
  uploadData: any;
  confirmationPopUp;
  actionType;

  constructor(private modalService: NgbModal,
    private utilService: UtilService, public activeModal: NgbActiveModal,
    private sharedService: SharedService, private cmnServ: CommonService,
    private validatorComponent: JsonValidatorComponent) { }

  ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges) {
    if (this.configObj?.data?.callPage == "session-details" && this.showFileUpload === false) {
      this.close();
    }
  }
  public dropped(files: NgxFileDropEntry[]) {
    if (!this.configObj?.isMultiUpload && files.length > 1) {
      this.utilService.snackMsg("Please select only one file.");
      return;
    }

    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        if (!this.configObj?.isMultiUpload) {
          this.configObj.UploadDisabled = false;
          let fileName = droppedFile.fileEntry.name;
          let fileExtension = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
          if (!this.isFileAllowed(fileExtension)) {
            this.utilService.snackMsg(`File extension of ${fileName.substring(0, fileName.lastIndexOf("."))} (${fileExtension}) is not valid.`, 5000);
            return;
          }

          this.files = [];
          this.files = files;
        }

        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          let name = file.name.substring(0, file.name.lastIndexOf("."));
          let result = this.validatorComponent.validateStrWithRegExp(this.configObj?.data?.fileNameRegex, name);
          if (!result) {
            this.utilService.snackMsg(`File name should have alpha Numeric and allow only - _ as special characters ( ${name} )`, 5000);
            return;
          } else {
            let uploadedImageNames = this.fileData.filter(item => item.name == file.name);
            if (uploadedImageNames.length == 0) {
              this.onFileChange(file);
            } else {
              this.utilService.snackMsg(`File name already exists ( ${file.name} )`);
              return;
            }
          }
        });
      } else {
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  onFileChange(file) {
    let reader: FileReader = new FileReader();
    reader.readAsText(file);
    reader.onload = (e) => {
      if (this.configObj?.isMultiUpload) {
        let multimediaData = {
          "fileType": "image",
          "fileData": file as File,
          "acceptedTypes": this.configObj.fileTypes,
          "maxSize": this.configObj.data.maxFileSize,
          "name": file.name,
          "maxWidth": this.configObj.data.maxWidth,
          "maxHeight": this.configObj.data.maxHeight,
          "isFixed": this.configObj.data.isFixed,
          "parentPathData": this.configObj.data.parentPathData
        }

        this.cmnServ.convertToBase64Data(multimediaData, (response) => {
          if (response.status) {
            let imgData = {
              'image_path': multimediaData.parentPathData + file.name,
              'image_data': this.cmnServ.convertToURLEncodeBase64(response["imageData"]),
              'name': file.name,
              'index': (this.fileData?.length == undefined) ? 0 : this.fileData.length,
              'preview_data': response["imageData"]
            };
            imgData.image_path = imgData?.image_path.replace(/ /g, "-");
            this.fileData.push(imgData);
          } else {
            this.utilService.snackMsg(response.msg);
            return;
          }
        });
      } else {
        this.linesR = [];
        let csv: any = reader.result as string;
        let allTextLines = [];
        allTextLines = csv.split('\n');
        allTextLines = allTextLines.filter(item => item.trim().length > 0);
        let arrl = allTextLines.length;
        allTextLines = allTextLines.map(str => str.replace(/\r/g, ''));

        if (this.configObj?.data?.callPage == "sensitiveDataFilter" || this.configObj?.data?.callPage == 'gameNotifications') {
          for (let i = 0; i < arrl; i++) {
            this.linesR.push(allTextLines[i].split(';'));
          }
        } else {
          const callPage = this.configObj?.data?.callPage;
          if (callPage === "session-details") {
            for (let i = 1; i < arrl; i++) {
              let rowVal = allTextLines[i].split(';')
              let data = rowVal[0].split(',')
              let fileContent = {
                "time": data[0],
                "game_id": data[1],
                "game_name": data[2],
                "start_time": data[3],
                "end_time": data[4],
                "days_of_month": data[5],
                "days_of_week": data[6],
              }
              this.linesR.push(fileContent);
            }
          } else {
            for (let i = 0; i < arrl; i++) {
              let line = allTextLines[i].split(',');
              const isNumeric = /^[0-9]+$/.test(line[0]);
              const isUpperCase = /^[A-Z]+$/.test(line[1]);
              const isSpecialChar = /^[A-Za-z0-9-_]+$/.test(line[2]);
              if (callPage === "managePrivateRoom" || callPage === "privateRoomSummury") {
                this.isValid = /Inc|Exc/.test(line[3]);
              } else {
                this.isValid = true;
              }
              if (!(isNumeric && isUpperCase && isSpecialChar)) this.isValid = false;
            }
            if (this.isValid) {
              for (let i = 0; i < arrl; i++) {
                this.linesR.push(allTextLines[i].split(';'));
              }
            }
          }
        }
      }
    }
  }

  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }

  upload() {
    if (this.configObj.isMultiUpload) {
      this.openConfirmPopup();
    } else {
      let csvObj;
      if (this.configObj?.data?.callPage == "privateRoomSummury") {
        this.configObj.UploadDisabled = true;
        csvObj = {
          "fileData": { "rows": this.linesR },
          "prtRoomID": this.configObj?.prID
        }
        this.sharedService.UploadedFileData.next(csvObj);
      } else {
        csvObj = { "rows": this.linesR };
        this.sharedService.CreateFileData.next(csvObj);
      }
    }
  }

  close() {
    this.modalService.dismissAll();
  }

  isFileAllowed(extension) {
    let isFileAllowed = false;
    const allowedFiles = (this.configObj) ? this.configObj?.fileTypes : [];

    if (extension) {
      for (const ext of allowedFiles) {
        if (extension.includes(ext)) {
          isFileAllowed = true;
        }
      }
    }
    return isFileAllowed;
  }

  openConfirmPopup(isDelete?, index?) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(GmsconfirmComponent, ngbModalOptions);
    modalRef.componentInstance.configObj = {
      "title": 'Confirmation',
      "message": `Are you sure you want to continue ${isDelete ? 'delete' : 'upload'} with the selected image (s) ?`,
      "btnOkText": 'Ok',
      "btnCancelText": 'Cancel'
    };
    modalRef.componentInstance.confirmed.subscribe((result) => {
      if (result && result == true) {
        if (isDelete) {
          this.fileData = this.fileData.filter(item => item.index !== index);
        } else {
          this.getFileData.emit(this.fileData);
          this.fileData = [];
        }
        console.log("Clicked OKay");
      } else {
        console.log("Cancel and dismiss");
      }
    });
  }

}